import { apiService } from "../../../shared/services/api/api.service";
import type {
  RecruitRegistrationRequest,
  RegistrationResponse,
  ValidateTokenResponse,
  ReferralLinkResponse,
} from "../types/registration.types";

class RegistrationService {
  /**
   * Validate a referral token
   */
  async validateReferralToken(token: string): Promise<ValidateTokenResponse> {
    const response = await apiService.get<ValidateTokenResponse>(
      `/registration/validate-token/${token}`
    );
    return response.data;
  }

  /**
   * Register a new recruit with referral token
   */
  async registerRecruit(
    data: RecruitRegistrationRequest
  ): Promise<RegistrationResponse> {
    const response = await apiService.post<RegistrationResponse>(
      "/registration/recruit",
      data
    );
    return response.data;
  }

  /**
   * Get referral link for authenticated user
   */
  async getReferralLink(): Promise<ReferralLinkResponse> {
    const response = await apiService.get<ReferralLinkResponse>(
      "/registration/referral-link"
    );
    return response.data;
  }

  /**
   * Generate a new referral token for authenticated user
   */
  async generateReferralToken(): Promise<{ success: boolean; data: { token: string } }> {
    const response = await apiService.post<{ success: boolean; data: { token: string } }>(
      "/registration/generate-token"
    );
    return response.data;
  }

  /**
   * Send invitation emails to potential recruits
   */
  async sendInvitation(emails: string[]): Promise<{
    success: boolean;
    data: { sent: number; failed: number; errors: string[] };
    message: string;
  }> {
    const response = await apiService.post<{
      success: boolean;
      data: { sent: number; failed: number; errors: string[] };
      message: string;
    }>("/registration/send-invitation", { emails });
    return response.data;
  }

  /**
   * Get referral stats for the authenticated agent
   */
  async getReferralStats(): Promise<{
    success: boolean;
    data: {
      totalRecruits: number;
      activeAgents: number;
      inOnboarding: number;
    };
  }> {
    const response = await apiService.get<{
      success: boolean;
      data: {
        totalRecruits: number;
        activeAgents: number;
        inOnboarding: number;
      };
    }>("/referral-analytics/my-stats");
    return response.data;
  }
}

const registrationService = new RegistrationService();
export default registrationService;

